import { AfterViewInit, Component, OnInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-pub-openings',
  templateUrl: './pub-openings.component.html',
  styleUrls: ['./pub-openings.component.css']
})
export class PubOpeningsComponent implements OnInit {

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
  }

  

}
